import EqualsFilterCondition from "../../components/FilterConditions/EqualsFilterCondition.js";
import NotEqualsFilterCondition from "../../components/FilterConditions/NotEqualsFilterCondition.js";
import ContainsFilterCondition from "../../components/FilterConditions/ContainsFilterCondition.js";
import NotContainsFilterCondition from "../../components/FilterConditions/NotContainsFilterCondition.js";
import GreaterThanCondition from "../../components/FilterConditions/GreaterThanCondition.js";
import LessThanCondition from "../../components/FilterConditions/LessThanCondition.js";
import GreaterThanOrEqualToCondition from "../../components/FilterConditions/GreaterThanOrEqualToCondition.js";
import LessThanOrEqualToCondition from "../../components/FilterConditions/LessThanOrEqualToCondition.js";
import {Text} from "react-aria-components";
import React from "react";

type FilterCondition = {
    fieldName: string | null;
    operator: string;
    value: string | null;
}

export function FilterConditions({conditions, setConditions, columnNames}: {
    conditions: FilterCondition[],
    setConditions: (conditions: FilterCondition[]) => void,
    columnNames: string[]
}) {

    function createEquals(condition, i) {
        return <EqualsFilterCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}

            aria-label="equals condition"
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions];
                newConditions[index].field = field;
                setConditions(newConditions);
            }}

            onValueChange={(index, e: Event) => {
                const value = e.target.value;
                const newConditions = [...conditions];
                newConditions[index].value = value;
                setConditions(newConditions);
            }}

            onDelete={(index) => {
                const newConditions = [...conditions];
                newConditions.splice(index, 1);
                setConditions(newConditions);
            }} ariaLabel={undefined}
        />
    }

    function createNotEquals(condition, i) {
        return <NotEqualsFilterCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions]
                newConditions[index].field = field;
                setConditions(newConditions)
            }}

            onValueChange={(index, e) => {
                const value = e.target.value
                const newConditions = [...conditions]
                newConditions[index].value = value;
                setConditions(newConditions)
            }}

            onDelete={(index) => {
                const newConditions = [...conditions]
                newConditions.splice(index, 1)
                setConditions(newConditions)
            }}
        />
    }

    function createContains(condition, i) {
        return <ContainsFilterCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions]
                newConditions[index].field = field;
                setConditions(newConditions)
            }}

            onValueChange={(index, e) => {
                const value = e.target.value
                const newConditions = [...conditions]
                newConditions[index].value = value;
                setConditions(newConditions)
            }}

            onDelete={(index) => {
                const newConditions = [...conditions]
                newConditions.splice(index, 1)
                setConditions(newConditions)
            }}
        />
    }

    function createNotContains(condition, i) {
        return <NotContainsFilterCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions]
                newConditions[index].field = field;
                setConditions(newConditions)
            }}

            onValueChange={(index, e) => {
                const value = e.target.value
                const newConditions = [...conditions]
                newConditions[index].value = value;
                setConditions(newConditions)
            }}

            onDelete={(index) => {
                const newConditions = [...conditions]
                newConditions.splice(index, 1)
                setConditions(newConditions)
            }}
        />
    }

    function createGreaterThan(condition, i) {
        return <GreaterThanCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions]
                newConditions[index].field = field;
                setConditions(newConditions)
            }}

            onValueChange={(index, e) => {
                const value = e.target.value
                const newConditions = [...conditions]
                newConditions[index].value = value;
                setConditions(newConditions)
            }}

            onDelete={(index) => {
                const newConditions = [...conditions]
                newConditions.splice(index, 1)
                setConditions(newConditions)
            }}
        />
    }

    function createLessThan(condition, i) {
        return <LessThanCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions]
                newConditions[index].field = field;
                setConditions(newConditions)
            }}

            onValueChange={(index, e) => {
                const value = e.target.value
                const newConditions = [...conditions]
                newConditions[index].value = value;
                setConditions(newConditions)
            }}

            onDelete={(index) => {
                const newConditions = [...conditions]
                newConditions.splice(index, 1)
                setConditions(newConditions)
            }}
        />
    }

    function createGreaterThanOrEquals(condition, i) {
        return <GreaterThanOrEqualToCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions]
                newConditions[index].field = field;
                setConditions(newConditions)
            }}

            onValueChange={(index, e) => {
                const value = e.target.value
                const newConditions = [...conditions]
                newConditions[index].value = value;
                setConditions(newConditions)
            }}

            onDelete={(index) => {
                const newConditions = [...conditions]
                newConditions.splice(index, 1)
                setConditions(newConditions)
            }}
        />
    }

    function createLessThanOrEquals(condition, i) {
        return <LessThanOrEqualToCondition
            key={"condition_" + i}
            index={i}
            options={columnNames}
            field={condition.field}
            value={condition.value}

            onFieldChange={(index, field) => {
                const newConditions = [...conditions]
                newConditions[index].field = field;
                setConditions(newConditions)
            }}

            onValueChange={(index, e) => {
                const value = e.target.value
                const newConditions = [...conditions]
                newConditions[index].value = value;
                setConditions(newConditions)
            }}

            onDelete={(index) => {
                const newConditions = [...conditions]
                newConditions.splice(index, 1)
                setConditions(newConditions)
            }}
        />
    }

    if (conditions.length === 0) {
        return <></>
    }

    const conditionInputs = [];
    conditions.forEach((condition, i) => {
        if (i > 0) {
            conditionInputs.push(<div className="and-wrapper">
                <Text key={"and_" + i} className="and">and</Text>
            </div>)
        }
        if (condition.operator === "==") conditionInputs.push(createEquals(condition, i))
        if (condition.operator === "!=") conditionInputs.push(createNotEquals(condition, i))
        if (condition.operator === "contains") conditionInputs.push(createContains(condition, i))
        if (condition.operator === "not contains") conditionInputs.push(createNotContains(condition, i))
        if (condition.operator === "greater than") conditionInputs.push(createGreaterThan(condition, i))
        if (condition.operator === "less than") conditionInputs.push(createLessThan(condition, i))
        if (condition.operator === "greater than or equals") conditionInputs.push(createGreaterThanOrEquals(condition, i))
        if (condition.operator === "less than or equals") conditionInputs.push(createLessThanOrEquals(condition, i))

    })

    return <div className="conditions">{conditionInputs}</div>
}